var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M8 0.00195312C3.584 0.00195312 0 3.58675 0 8.00195C0 12.4188 3.584 16.002 8 16.002C12.424 16.002 16 12.4188 16 8.00195C16 3.58675 12.424 0.00195312 8 0.00195312Z",
    fill: "url(#paint0_linear_5575_191960)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00087 4.26562C7.61688 4.26562 7.29688 4.58642 7.29688 4.96962V8.50562C7.29688 8.89042 7.61688 9.20162 8.00087 9.20162C8.38488 9.20162 8.69687 8.89042 8.69687 8.50562V4.96962C8.69687 4.58642 8.38488 4.26562 8.00087 4.26562ZM7.30664 11.0422C7.30664 11.4262 7.61864 11.7462 8.01064 11.7462C8.39464 11.7462 8.70664 11.4262 8.70664 11.0422C8.70664 10.6582 8.39464 10.3462 8.00264 10.3462C7.61864 10.3462 7.30664 10.6582 7.30664 11.0422Z",
    fill: "url(#paint1_linear_5575_191960)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5575_191960",
    x1: 0,
    y1: 0.00195312,
    x2: 0,
    y2: 16.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D09600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5575_191960",
    x1: 7.29688,
    y1: 4.26562,
    x2: 7.29688,
    y2: 11.7462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAA900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D09600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.70e9e10e0a281e4bb7409e7a533c4e90.svg";
export { ForwardRef as ReactComponent };